import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchLeavesByUserId,
  createLeave,
  updateLeave,
  deleteLeave,
} from "../../../store/slices/LeaveSlice";
import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../components/Breadcrumbs";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeLeaveModelPopup from "../../../components/modelpopup/EmployeeLeaveModelPopup";
import Loading from "../../../hooks/utils/Loading/Loading";
import { toast } from "react-toastify";

const EmployeeLeave = () => {
  const dispatch = useDispatch();
  const leaves = useSelector((state) => state.leave.leaves);
  const userInfo = useSelector((state) => state.auth.userInfo);

  const isLoading = useSelector(
    (state) => state.leave.status.fetchByUserId === "loading"
  );
  useSelector((state) => state.leave.error.fetchByUserId);
  const [showAddLeaveModal, setShowAddLeaveModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  useEffect(() => {
    if (userInfo && userInfo.id) {
      dispatch(fetchLeavesByUserId(userInfo.id));
    }
  }, [dispatch, userInfo]);

const handleAddLeave = () => {
  setShowAddLeaveModal(true);
  setSelectedLeave(null);
};

  const confirmDeleteLeave = () => {
    if (selectedLeave) {
      dispatch(deleteLeave(selectedLeave));
      setShowDeleteModal(false);
      setSelectedLeave(null);
      dispatch(fetchLeavesByUserId(userInfo.id));
    }
  };

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "leaveType",
    },
    {
      title: "From",
      dataIndex: "startDate",
      render: (text) => <span>{new Date(text).toLocaleDateString()}</span>,
    },
    {
      title: "To",
      dataIndex: "endDate",
      render: (text) => <span>{new Date(text).toLocaleDateString()}</span>,
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Status",
      dataIndex: "status",
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Leaves"
            title="Main"
            subtitle="My Leaves"
            modalClass="d-none col-auto float-end ms-auto"
          />

          <div className="row mb-3">
            <div className="col-md-3">
              <button className="btn btn-primary" onClick={handleAddLeave}>
                Add Leave
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive mb-3">
                <Table
                  columns={columns}
                  dataSource={leaves}
                  rowKey={(record) => record._id}
                  pagination={{
                    current: currentPage,
                    pageSize: pageSize,
                    total: leaves.length,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setPageSize(pageSize);
                    },
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                  }}
                  locale={{
                    emptyText: isLoading ? (
                      <div>
                        <Loading />
                      </div>
                    ) : (
                      "No Data"
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showAddLeaveModal && (
        <EmployeeLeaveModelPopup
          leave={selectedLeave}
          closeModal={() => setShowAddLeaveModal(false)}
          onSubmit={async (data) => {

            if (selectedLeave) {
              // Update leave
              const resultAction = await dispatch(
                updateLeave({ id: selectedLeave._id, leaveData: data })
              );
              if (resultAction.payload && resultAction.payload.error) {
                toast.error("Error: " + resultAction.payload.error);
              } else {
                toast.success("Leave updated successfully!");
              }
            } else {
              // Create leave
              const resultAction = await dispatch(createLeave(data));
              if (resultAction.error) {
                toast.error("Error: " + resultAction?.payload);
              } else {
                toast.success("Leave Request Sent!");
              }
            }

            await dispatch(fetchLeavesByUserId(userInfo.id));
            setShowAddLeaveModal(false);
          }}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onDeleteLeave={confirmDeleteLeave}
          closeModal={() => setShowDeleteModal(false)}
        />
      )}
    </>
  );
};

export default EmployeeLeave;
